module.exports = __webpack_public_path__ + "img/logo.12e46957.svg";